import { memo, useCallback, useRef, useState } from 'react'
import { useIsLogin } from 'store/account/hooks'
import { IconArrowDown } from 'components/Icons'
import { Button, Stack, styled } from '@mui/material'
import { useCancelAllStore } from 'components/CancelModal/store'

const Wrap = styled('div')`
  display: flex;
  width: 100%;
  position: relative;
  justify-content: flex-end;
`
export const StyledCancelAllButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  user-select: none;
  padding: 0;

  &:hover {
    cursor: pointer;
    background-color: unset;
    color: rgba(160, 238, 9, 1);
  }
  &.disabled {
    color: ${(props) => props.theme.color.sell20};
    cursor: initial;
  }
`
const Popup = styled(Stack)`
  gap: 4px;
  padding: 8px 4px;
  background: rgba(30, 35, 41, 1);
  border: 1px solid rgba(42, 49, 57, 1);
  border-radius: 4px;
  width: 102px;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
`
const PopupItem = styled('div')`
  display: flex;
  height: 32px;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  padding: 0 8px;
  cursor: pointer;

  &.active,
  &:hover {
    color: rgba(160, 238, 9, 1);
  }
`
export const CancelAllButton = memo<{
  pending?: boolean
  visible?: boolean
  onClick?(type: 'ALL' | 'LIMIT' | 'STOP'): void
}>(({ visible = true, pending = false, onClick }) => {
  const isLogin = useIsLogin()
  const { updateCancelAllType } = useCancelAllStore()
  const [open, setOpen] = useState<boolean>(false)
  const timer = useRef<any>(null)

  const handleClick = useCallback(
    (type: 'ALL' | 'LIMIT' | 'STOP') => {
      return () => {
        updateCancelAllType(type)
        onClick && onClick(type)
      }
    },
    [onClick, updateCancelAllType],
  )

  if (!isLogin) {
    return null
  }

  if (!visible) {
    return null
  }

  return (
    <Wrap>
      <StyledCancelAllButton
        className={pending ? 'disabled' : ''}
        onClick={() => {
          onClick && onClick('ALL')
        }}
        onMouseEnter={() => {
          clearTimeout(timer.current)
          setOpen(true)
        }}
        onMouseLeave={() => {
          timer.current = setTimeout(() => {
            setOpen(false)
          }, 200)
        }}
      >
        {pending ? 'Pending' : 'Cancel All'}
        <IconArrowDown />
      </StyledCancelAllButton>
      {open && (
        <Popup
          onMouseEnter={() => {
            clearTimeout(timer.current)
          }}
          onMouseLeave={() => setOpen(false)}
        >
          <PopupItem onClick={handleClick('ALL')}>All</PopupItem>
          <PopupItem onClick={handleClick('LIMIT')}>Limit</PopupItem>
          <PopupItem onClick={handleClick('STOP')}>Stop</PopupItem>
        </Popup>
      )}
    </Wrap>
  )
})
